module.exports = __webpack_public_path__ + "static/media/default.38851b82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/default.jpg
// module id = 1881
// module chunks = 0